// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalAddCredential_modalContainer__1nhLP","table":"ModalAddCredential_table__HL4aA","table_invisible":"ModalAddCredential_table_invisible__yCFKP"};